module.exports = __webpack_public_path__ + "media/3_3.ce92bdde.wav";